var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,12h-8c-2.7568,0-5-2.2432-5-5v-2c0-.5522,.4478-1,1-1h16c.5522,0,1,.4478,1,1v2c0,2.7568-2.2432,5-5,5Zm-11-6v1c0,1.6543,1.3457,3,3,3h8c1.6543,0,3-1.3457,3-3v-1h-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,60H23c-4.9624,0-9-4.0376-9-9V13c0-4.9624,4.0376-9,9-9h18c4.9624,0,9,4.0376,9,9V51c0,4.9624-4.0376,9-9,9ZM23,6c-3.8599,0-7,3.1401-7,7V51c0,3.8599,3.1401,7,7,7h18c3.8599,0,7-3.1401,7-7V13c0-3.8599-3.1401-7-7-7H23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 36,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,54h-14c-.5522,0-1-.4478-1-1V21c0-.5522,.4478-1,1-1h14c.5522,0,1,.4478,1,1V53c0,.5522-.4478,1-1,1Zm-13-2h12V22h-12v30Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,30h-4c-.5522,0-1-.4478-1-1v-2c0-1.6543,1.3457-3,3-3s3,1.3457,3,3v2c0,.5522-.4478,1-1,1Zm-3-2h2v-1c0-.5513-.4487-1-1-1s-1,.4487-1,1v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,34h-6c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h6c.5522,0,1,.4478,1,1v4c0,.5522-.4478,1-1,1Zm-5-2h4v-2h-4v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,46h-4c-.5522,0-1-.4478-1-1v-2c0-1.6543,1.3457-3,3-3,.772,0,1.5054,.2925,2.0645,.8237,.4004,.3804,.417,1.0132,.0366,1.4136-.3809,.3999-1.0132,.417-1.4136,.0366-.186-.1768-.4302-.2739-.6875-.2739-.5513,0-1,.4487-1,1v1h3c.5522,0,1,.4478,1,1s-.4478,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,50h-6c-.5522,0-1-.4478-1-1v-4c0-.5522,.4478-1,1-1h6c.5522,0,1,.4478,1,1v4c0,.5522-.4478,1-1,1Zm-5-2h4v-2h-4v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,18h-10c-.5522,0-1-.4478-1-1s.4478-1,1-1h10c.5522,0,1,.4478,1,1s-.4478,1-1,1Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/Brand.5f67fb8b27c7dd98040ae996bfa3910a.svg";
export { ForwardRef as ReactComponent };